import { AnalyticAction } from '@application/analytic/analytic.service';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import { LicenceHolderService } from '@services/licence_holder.service';
import { useCountedIssues } from '@services/unhandled_issues.service/use_counted_issues';
import { useService } from '@visiba/instantiation';
import { Item } from '../_item.component';

interface Props {
	__TEMP__navigate?: (url: string) => void;
	trackEvent(event: AnalyticAction): void;
}

export function LinkMyCases({ trackEvent, __TEMP__navigate }: Props): JSX.Element {
	const countedIssues = useCountedIssues(['ongoing', 'completed']);
	const licenceHolderService = useService(LicenceHolderService);

	function handleClick(): void {
		trackEvent('Clicked: My cases-tab');
	}

	return (
		<Item
			to={`/${licenceHolderService.alias}/visits`}
			icon='visits'
			iconActive='visits_filled'
			label={withTranslation('PW.Component.Header.Picker.Visit.Label')}
			data-testid='header_link_visits'
			badgeNumber={countedIssues}
			__TEMP__navigate={__TEMP__navigate}
			onClick={handleClick}
		/>
	);
}
